class FadeUp {
	constructor( el ) {

		const anim = gsap.fromTo(el,
			{autoAlpha: 0, y: 40},
			{duration: 0.5, autoAlpha: 1, y: 0}
		);

		ScrollTrigger.create({
			trigger: el,
			start: "top 90%",
			animation: anim,
			toggleActions: 'play none complete none',
		});

	}
}


export default FadeUp;
